module.exports = __webpack_public_path__ + "static/img/mr1.f0f11e73.png";